import { motion } from "framer-motion";

export default function WhyUs({ items }) {
  return (
    <section id="why-us" className="max-w-7xl mx-auto px-6 py-20 lg:py-28" data-testid="why-us-section">
      <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-[#FF5A1F]" data-testid="why-us-eyebrow">Why AZ Concepts</p>
      <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-extrabold tracking-tight max-w-2xl" data-testid="why-us-heading">
        Built for wholesale buyers who need reliability
      </h2>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {items.map((item, i) => (
          <motion.div key={item.title}
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
            className="bg-[#161B22] border border-white/10 rounded-2xl p-8 hover:border-[#FF5A1F]/40 hover:-translate-y-1 transition-all"
            data-testid={`why-us-card-${i}`}>
            <span className="font-heading text-4xl font-extrabold text-[#FF5A1F]/30">0{i + 1}</span>
            <h3 className="mt-4 font-heading text-lg font-bold">{item.title}</h3>
            <p className="mt-2 text-sm text-slate-400 leading-relaxed">{item.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
